import { render, staticRenderFns } from "./DamageAssessor.vue?vue&type=template&id=4b7b9510&scoped=true"
import script from "./DamageAssessor.vue?vue&type=script&lang=js"
export * from "./DamageAssessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b9510",
  null
  
)

export default component.exports